import type { OrganisationLookup } from '../types/organisation-lookup.type';
import { BusinessAreaLookupModel } from './business-area-lookup.model';

export class OrganisationLookupModel implements OrganisationLookup {
  readonly businessAreas: BusinessAreaLookupModel[] | null = null;

  constructor(data: OrganisationLookup) {
    if (data.businessAreas) {
      this.businessAreas = data.businessAreas.map(
        (item) => new BusinessAreaLookupModel(item),
      );
    }
  }
}
